import {AccountUser} from './AccountUser';
import {Customer} from './Customer';
import {User} from './User';

export type Account = {
  id?: number;
  uid: string;
  pricing_tier_uid?: string;
  name: string;
  email?: string;
  is_active: boolean;
  account_user: Array<AccountUser>;
  account_users: Array<AccountUser>;
  createdAt: string;
  updatedAt: string;
  kind: string;
  user?: User;
};

export type GetAccountV2Response = {
  id?: number;
  uid: string;
  name: string;
  markup: string;
  pricing_tier_uid?: string;
  is_active: boolean;
  createdAt: string;
  updatedAt: string;
  parent_account_uid?: string;
  registration_type?: string;
  utm_tags?: string;
  account_unique_key?: string;
  account_users: Array<AccountUser>;
  account_user: Array<AccountUser>;
  kind: string;
  customer?: Customer;
};

export type GetAccountsRequestData = {
  name?: string;
  kind?: string;
};

export type AccountsQueryResponse = Array<Account>;

export const initialAccount: Account = {
  uid: '',
  name: '',
  is_active: false,
  account_user: [],
  account_users: [],
  createdAt: '',
  updatedAt: '',
  kind: '',
};

export interface CreateAccountResponse {
  message: string;
  createdUser: CreatedUser;
}

export interface CreatedUser {
  professionalAccount: ProfessionalAccount;
  accounts: Account[];
  credentials: Credentials;
}

export interface InvitedUser {
  message: string;
  createdPersonalAccount: any;
  mainAccountUserRelation: AccountUserRelation;
}

export interface ProfessionalAccount {
  id: number;
  uid: string;
  pricing_tier_uid: any;
  name: string;
  is_active: boolean;
  kind: string;
  createdAt: string;
  updatedAt: string;
}

export interface Account_user {
  id: number;
  uid: string;
  account_id: number;
  user_id: number;
  role: string;
  is_active: boolean;
  createdAt: string;
  updatedAt: string;
  account: Account;
}

export interface Credentials {
  username: string;
  sub: string;
}

export interface AccountUserRelation {
  name: string;
  role: string;
  kind: string;
}
export type CustomerAccount = {
  user_accounts_id: number;
  user_external_uid: string;
  personal_account: ProfessionalAccount;
};

export type CreateProviderAccountRequest = {
  user: {
    name: string;
    email: string;
    phone_number: string;
    contact_type: 'owner' | 'buyer' | 'financial' | 'sales';
  };
  provider_info: {
    existing_provider_uid: string;
    existing_warehouse_uid: string;
  };
  registration_origin: 'partner_hub';
};
